import React, { useState } from 'react';

import { getIsMobile } from '@src/core/utils';

export const DeviceContext = React.createContext(null);

export interface deviceType {
  isMobile: boolean;
  setIsMobile: any;
}

export const DeviceProvider: React.FC<{}> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(getIsMobile());

  const value = {
    isMobile,
    setIsMobile,
  };

  return <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>;
};
